import React from 'react';
import { Reveal } from './Reveal';
const featureStats = [{
  value: '+180',
  label: 'Pages'
}, {
  value: '6',
  label: 'Modules Thématiques'
}, {
  value: '+500',
  label: 'Supports Cliniques'
}, {
  value: '★',
  label: "Tous Niveaux d'Intervention"
}];
const domains = ['Dépistage', 'Évaluation', 'Intervention', 'Suivi', 'Bilan', 'Communication', 'Administration', 'Rééducation', 'Progression', 'Préparation de séance'];
export function SystemIntro() {
  return <section className="w-full bg-black px-4 py-20" data-id="element-231">
      <div className="mx-auto max-w-4xl text-center" data-id="element-232">
        <Reveal data-id="element-233">
          <p className="text-sm font-bold uppercase tracking-widest text-gold" data-id="element-234">
            🏆 Le système complet pour arrêter d'improviser vos interventions
            cliniques
          </p>
          <h2 className="mt-5 font-display text-4xl uppercase leading-[0.95] text-white sm:text-5xl" data-id="element-235">
            Le protocole clinique en 4 étapes
            <span className="align-super text-2xl text-gold" data-id="element-236">™</span>
          </h2>
          <p className="mt-4 text-lg font-semibold text-white/80" data-id="element-237">
            1 Volume Complet + 5 Outils Complémentaires
          </p>
          <p className="mt-4 text-white/60" data-id="element-238">
            Plus de 180 pages. Plus de 32 protocoles d'intervention
            professionnels. Supports techniques pour évaluation, rééducation et
            suivi. Gestion du cabinet. Tout prêt.
          </p>
        </Reveal>

        <Reveal delay={0.1} data-id="element-239">
          <div className="mt-12 grid grid-cols-2 gap-6 md:grid-cols-4" data-id="element-240">
            {featureStats.map(s => <div key={s.label} className="flex flex-col items-center rounded-2xl border border-ink-border bg-ink-card p-5" data-id="element-241">
                <span className="font-display text-3xl text-gold sm:text-4xl" data-id="element-242">
                  {s.value}
                </span>
                <span className="mt-2 text-xs font-semibold uppercase tracking-wide text-white/55" data-id="element-243">
                  {s.label}
                </span>
              </div>)}
          </div>
        </Reveal>

        <Reveal delay={0.15} data-id="element-244">
          <p className="mt-14 text-lg font-bold text-white" data-id="element-245">
            Couverture complète, tous les domaines.
          </p>
          <div className="mt-6 flex flex-wrap justify-center gap-2.5" data-id="element-246">
            {domains.map(d => <span key={d} className="rounded-full border border-ink-border bg-ink-card px-4 py-2 text-sm font-medium text-white/75" data-id="element-247">
                {d}
              </span>)}
          </div>
        </Reveal>
      </div>
    </section>;
}